export default "/_next/static/images/circleCheckmark-0a18ea8aaea4ca20fd6298756f0f106c.svg";